(function () {
  'use strict';
  if (window.__lynkProductWorldV31) return;
  window.__lynkProductWorldV31 = true;
  const active = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function mount(root) {
    if (active.has(root)) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const rails = Array.from(root.querySelectorAll('[data-v31-rail]'));
    let frame = 0;
    function update() {
      frame = 0;
      rails.forEach(rail => {
        const section = rail.closest('section');
        const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const position = Math.max(0, Math.min(max, rail.scrollLeft));
        section.querySelectorAll('[data-v31-step]').forEach(button => {
          button.hidden = max < 2;
          button.disabled = Number(button.dataset.v31Step) < 0 ? position < 2 : position > max - 2;
        });
        const progress = section.querySelector('[data-v31-progress]');
        if (progress) {
          progress.hidden = max < 2;
          progress.value = max ? Math.round(100 * position / max) : 100;
        }
      });
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    rails.forEach(rail => {
      rail.addEventListener('scroll', schedule, { passive: true, signal });
      rail.addEventListener('keydown', event => {
        if (event.target !== rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        rail.scrollBy({ left: (event.key === 'ArrowLeft' ? -1 : 1) * (rail.firstElementChild?.getBoundingClientRect().width || rail.clientWidth), behavior: reduced.matches ? 'auto' : 'smooth' });
      }, { signal });
    });
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-v31-step]');
      if (!button || !root.contains(button)) return;
      const rail = button.closest('section')?.querySelector('[data-v31-rail]');
      rail?.scrollBy({ left: Number(button.dataset.v31Step) * (rail.firstElementChild?.getBoundingClientRect().width || rail.clientWidth), behavior: reduced.matches ? 'auto' : 'smooth' });
    }, { signal });
    window.addEventListener('resize', schedule, { passive: true, signal });
    update();
    active.set(root, () => { controller.abort(); if (frame) cancelAnimationFrame(frame); });
  }
  function initialize() {
    for (const [root, dispose] of active) if (!root.isConnected) { dispose(); active.delete(root); }
    document.querySelectorAll('[data-v31-collection]').forEach(mount);
  }
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => { for (const [root, dispose] of active) if (event.target.contains(root)) { dispose(); active.delete(root); } });
  window.addEventListener('pagehide', () => { for (const dispose of active.values()) dispose(); active.clear(); });
  window.addEventListener('pageshow', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true }); else initialize();
}());
